@if (headerLeftImage(item().type); as leftImage) {
  <span class="countdown-bar__header-piece"><img [src]="leftImage" alt=""></span>
} @else {
  <span class="countdown-bar__header-piece"><span class="countdown-bar__big-label">BIG</span></span>
}
<span class="countdown-bar__divider countdown-bar__divider_left"></span>
<span class="countdown-bar__header-piece"><img [src]="brandImage(item().type)" alt=""></span>
<span class="countdown-bar__divider divider_right"></span>
@if (collapsed()) {
  <bingo-countdown-bar-time [item]="item()" class="countdown-bar__collapsed-time" />
} @else {
  <button type="button" class="countdown-bar__hide" (click)="hide.emit($event)">
    <img [src]="hideButtonImage" alt="">
    <span>HIDE</span>
  </button>
  <bingo-countdown-bar-time [item]="item()" class="countdown-bar__hide-time" />
}
